import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Checkbox, HelpBlock, Panel } from 'react-bootstrap'

import { FormGroup } from 'internal-components/src/components/Form'
import { SignupWithExternalsRecord } from 'internal-components/src/records'

export default function PartnerConfirmation({
  errors,
  partnerApproved,
  setPartnerApproved,
  signupWithExternals,
}) {
  return (
    <Panel bsStyle="warning">
      <Panel.Body>
        <h3>Partner Authorisation</h3>

        <p>
          This signup has been partially created by{' '}
          <em>{signupWithExternals.partner.name}</em> on your behalf. If you
          continue with the signup and leave the checkbox selected below,{' '}
          <em>{signupWithExternals.partner.name}</em> will be granted access to
          manage the technical aspects of your service.
        </p>

        <p>
          You can manage this relationship at any point in the future by logging
          into our <a href="https://portal.infinite.net.au">customer portal</a>,
          or calling us during business hours on <tel>1300 790 337</tel>.
        </p>

        <FormGroup
          bsSize="large"
          controlId="partnerConfirm"
          errors={errors}
          errorKey="terms"
        >
          <Checkbox
            checked={partnerApproved}
            onChange={e => setPartnerApproved(e.target.checked)}
          >
            <strong>
              I authorise <em>{signupWithExternals.partner.name}</em> as a
              technical representative for this service.
            </strong>
          </Checkbox>

          <HelpBlock>
            A technical representative can contact us on your behalf for
            technical issues regarding your service. They are not granted access
            to billing and account modification.
          </HelpBlock>
        </FormGroup>
      </Panel.Body>
    </Panel>
  )
}

PartnerConfirmation.propTypes = {
  errors: Ipt.map.isRequired,
  partnerApproved: Pt.bool.isRequired,
  setPartnerApproved: Pt.func.isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/PartnerConfirmation.jsx